
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources/c/[...slug]",
      function () {
        return require("private-next-pages/resources/c/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resources/c/[...slug]"])
      });
    }
  